import { useMutation } from '@tanstack/react-query';

import { WoltGoodsReceiptCreateRequest } from 'common/api-types/warehouse';
import { UseMutationConfig } from 'common/query/types';
import { useApiQueryClient } from 'common/query/useApiQueryClient';
import { AxiosWarehouseError } from 'common/types';
import {
  WAREHOUSE_ITEM_QUERY_KEY_ROOT,
  WAREHOUSE_ITEMS_QUERY_KEY_ROOT,
} from 'features/warehouse/common/query';

import { createGoodsReceipt } from './api';
import { GOODS_RECEIPTS_QUERY_KEY_ROOT } from './query';

export const useCreateGoodsReceiptMutation = (
  warehouseId: string,
  itemId: string,
  options: UseMutationConfig<void, AxiosWarehouseError, WoltGoodsReceiptCreateRequest>,
) => {
  const queryClient = useApiQueryClient();

  return useMutation<any, AxiosWarehouseError, WoltGoodsReceiptCreateRequest>({
    ...options,
    mutationFn: (data) => createGoodsReceipt(warehouseId, itemId, data),
    onSuccess: (...args) => {
      void queryClient.invalidateQueries({
        queryKey: [GOODS_RECEIPTS_QUERY_KEY_ROOT, { warehouseId }],
      });
      void queryClient.invalidateQueries({ queryKey: [WAREHOUSE_ITEMS_QUERY_KEY_ROOT] });
      void queryClient.invalidateQueries({ queryKey: [WAREHOUSE_ITEM_QUERY_KEY_ROOT] });
      void options.onSuccess?.(...args);
    },
  });
};
